module.exports = __webpack_public_path__ + "img/Sorcière.a0a0fa11.png";